
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password_reset_request",
      function () {
        return require("private-next-pages/password_reset_request/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password_reset_request"])
      });
    }
  